import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '../translate.pipe';

@Pipe({
  name: 'translateMediumDate',
})
export class TranslateMediumDatePipe implements PipeTransform {
  month: number;
  day: number;
  year: number;

  constructor(private translate: TranslatePipe) {}

  transform(date: Date | number): string {
    const dateCopy = new Date(date);
    this.month = dateCopy.getMonth();
    this.day = dateCopy.getDate();
    this.year = dateCopy.getFullYear();
    return `${this.translate.transform(`date.month.short.m${this.month}`)} ${this.day}, ${this.year}`;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/pipes/translate-medium-date.pipe.ts